import { ReactElement, useState } from 'react';
import {
  MultiContextPlan,
  SeatingPlanPurchase,
  StockManagement,
  MULTI_CONTEXT_PLAN_NAMES,
} from '@mapado/seating';
import EventDatePagesHeader from '../components/EventDatePagesHeader';
import { getCart } from '../entityFactory';
import useQueryNumberParam from '../useQueryNumberParam';

export default function DemoMultiContext(): ReactElement {
  const [index, setIndex] = useState<MULTI_CONTEXT_PLAN_NAMES | null>(null);
  const eventDateId = useQueryNumberParam('eventDateId', 133018);

  return (
    <>
      <EventDatePagesHeader title="Multi-contextes" eventDateId={eventDateId} />

      <MultiContextPlan
        selectedIndex={index}
        onSelectIndex={setIndex}
        hiddenPlanContext={[]}
        planList={[
          {
            name: MULTI_CONTEXT_PLAN_NAMES.SEATING_PLAN_PURCHASE,
            render: () => (
              <SeatingPlanPurchase
                eventDateId={eventDateId}
                // @ts-expect-error -- don't really care about the type here
                // eslint-disable-next-line no-console
                setTicketPriceQuantity={console.log}
                // eslint-disable-next-line no-console
                lockSeatsForEventDate={console.log}
                cart={getCart()}
                currentContingentId={null}
              />
            ),
          },
          {
            name: MULTI_CONTEXT_PLAN_NAMES.STOCK_MANAGEMENT,
            render: () => <StockManagement eventDateId={eventDateId} />,
          },
        ]}
      />
    </>
  );
}
